module.exports = __webpack_public_path__ + "img/vivobook6.1019c3a4.jpg";